<template>
    <Layout>
        <section class="section">
            <div class="container">
                <div class="row">
                    <div
                        class="col-md-6 animated mb-30"
                        data-animation="fadeIn"
                    >
                        <span class="section-icon icon icon-medical-16"></span>
                        <h5>To and from airport</h5>
                        <p>
                            Transportation services to and from the airport can
                            be arranged directly through the concierge desk at
                            the Atlantis Hotel for a charge.
                        </p>
                    </div>
                    <div
                        class="col-md-6 animated mb-30"
                        data-animation="fadeIn"
                        data-delay="100"
                    >
                        <span
                            class="section-icon icon icon-documents-bookmarks-08"
                        ></span>
                        <h5>Other Services</h5>
                        <p>
                            Atlantis, The Palm will be responsible for the below
                            additional services throughout the conference.
                            Kindly consult their website or contact them for
                            questions regarding the following:
                        </p>
                        <ul class="bullets">
                            <li>Help obtaining visas</li>
                            <li>Airport meet and greet service</li>
                            <li>Arrangement of ground transportation</li>
                            <li>Coordination of private aircraft logistics</li>
                            <li>Arrangement of excursions</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <section
            class="section section-double left gray-clr-bg"
            style="height: 35vw"
        >
            <div class="image col-lg-6">
                <div class="bg-image">
                    <img src="assets/img/hotel/atlantis-6.jpg" alt="" />
                </div>
            </div>

            <div class="content col-lg-6 animated" data-animation="fadeIn">
                <h2>Contact Information</h2>
                <p>
                    Crescent Road, The Palm Island<br />
                    P.O.Box 211222, Dubai, UAE
                </p>
                <ul class="list">
                    <li>Phone: +971 4 426 2000</li>
                    <li>
                        Email:
                        <a href="mailto:info@atlantisthepalm.com"
                            >info@atlantisthepalm.com</a
                        >
                    </li>
                    <li>
                        <a
                            target="_blank"
                            href="https://www.atlantisthepalm.com/"
                            >Hotel Website</a
                        >
                    </li>
                </ul>
            </div>
        </section>

        <section class="section">
            <div class="container">
                <div class="no-free-will">
                    <div class="row">
                        <div class="bottom-links">
                            <div class="col-md-6">
                                <a
                                    href="#"
                                    class="btn btn-sm btn-secondary btn-block"
                                    >Participation Guidelines (Presenters)</a
                                >
                            </div>
                            <div class="col-md-6">
                                <a
                                    href="#"
                                    class="btn btn-sm btn-secondary btn-block"
                                    >Brochure (Investors)</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";

export default {
    name: "AdditionalServices",
    components: { Layout }
};
</script>
